import React from 'react';
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
  FaTwitter,
} from 'react-icons/fa';

import DHL from '../../image/dhl.png';
import Caisse from '../../image/caisse.png';
import Wave from '../../image/wve.png';
import OrangeMoney from '../../image/orangemoney.png';
import Visa from '../../image/visa.png';
import ApplePay from '../../image/pay.png';
import GooglePay from '../../image/google-pay.png';
import Mastercard from '../../image/mastercard.png';
import Logo from '../../image/logo.png';

const Footer = () => {
  return (
    <footer className="lp-footer">
      <div className="lp-footer-inner">
        <div className="lp-footer-top">
          <div>
            <h5>Notre partenaire</h5>
            <div className="lp-footer-partners">
              <img src={DHL} alt="DHL" />
            </div>
          </div>
          <div>
            <h5>Nos modes de paiement</h5>
            <div className="lp-footer-payments">
              <img src={Caisse} alt="Carte bancaire" />
              <img src={Wave} alt="Wave" />
              <img src={OrangeMoney} alt="Orange Money" />
              <img src={Visa} alt="Visa" />
              <img src={ApplePay} alt="Apple Pay" />
              <img src={GooglePay} alt="Google Pay" />
              <img src={Mastercard} alt="Mastercard" />
            </div>
          </div>
        </div>

        <hr className="lp-footer-divider" />

        <div className="lp-footer-main">
          <div className="lp-footer-brand">
            <img src={Logo} alt="Easy Compta" />
            <p>
              La solution comptable pensée pour les entrepreneurs sénégalais.
              Simple, sécurisée et adaptée à vos besoins.
            </p>
            <div className="lp-footer-social">
              <a href="#" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="#" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="#" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          <div>
            <h6>Produit</h6>
            <ul>
              <li>Fonctionnalités</li>
              <li>Tarifs</li>
              <li>Démo</li>
              <li>API</li>
            </ul>
          </div>

          <div>
            <h6>Support</h6>
            <ul>
              <li>Centre d&apos;aide</li>
              <li>Tutoriels</li>
              <li>Contact</li>
              <li>Statut</li>
            </ul>
          </div>

          <div>
            <h6>Contact</h6>
            <ul className="lp-footer-contact">
              <li>
                <FaEnvelope /> contact@easycompta.sn
              </li>
              <li>
                <FaPhone /> +221 77 000 00 00
              </li>
              <li>
                <FaMapMarkerAlt /> Dakar, Sénégal
              </li>
            </ul>
          </div>
        </div>

        <hr className="lp-footer-divider" />

        <p className="lp-footer-copyright">
          © 2025 Easy Compta. Tous droits réservés. Made with ❤️ in Sénégal
        </p>
      </div>
    </footer>
  );
};

export default Footer;
